import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { BookingService } from 'src/app/modules/shared/services/booking.service';
import { FormatAgesPipe } from 'src/app/modules/shared/pipes/format-ages.pipe';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'detail-occupancy',
  templateUrl: './detail-occupancy.component.html',
  styleUrls: ['./detail-occupancy.component.scss']
})
export class DetailOccupancyComponent implements OnInit, OnDestroy {

  guestsAges: number[];
  oldGuestsAges: number[];
  guestString : string = '';

  ocupancySubscription: Subscription;

  adultsAges: number[];
  childrenAges: number[];
  maxGuests: number = 5;  //TODO Prendere informazione dal service

  @ViewChild('a') accordion: NgbAccordion;

  constructor(
    private _bookingService: BookingService,
    private _formatAges: FormatAgesPipe,
    ) { }

  ngOnInit(): void {

    //  Occupancy Subscription
    this.ocupancySubscription = this._bookingService.occupancy$.subscribe(occupancy => {
      this.guestsAges = occupancy.ages;
      this.guestString = this._formatAges.transform(this.guestsAges,'full_formatted');
      this.oldGuestsAges = [...this.guestsAges.sort((a,b) => b-a )];
      this.splitAges();
    });

  }

  ngOnDestroy(): void {
    this.ocupancySubscription.unsubscribe();
  }

  //  Suddivide le età degli ospiti (fornite come array) in età degli adulti ed età dei bambini
  splitAges() {
    this.adultsAges = this.guestsAges.filter(age => age >= 18);
    this.childrenAges = this.guestsAges.filter(age => age < 18);
  }

  trackByAges(index: number): number {
    return index;
  }

  //  Assembra array con età di adulti e bambini
  mergeAges() {
    this.guestsAges = [...this.adultsAges, ...this.childrenAges].map(age => Number(age)).sort((a,b) => b-a );
  }

  //  Se il numero massimo di ospiti è stato raggiunto
  maxGuestNumberReached(): boolean {
    return this.childrenAges.length + this.adultsAges.length >= this.maxGuests;
  }

  addChild() {
    this.childrenAges.push(0);
  }
  addAdult() {
    this.adultsAges.push(35);
  }
  removeChild() {
    this.childrenAges.pop();
  }
  removeAdult() {
    this.adultsAges.pop();
  }

  //  Effettua controllo su ogni singola età inserita dall'utente per verificare che sia valida
  checkAgeInput(index) {
    let age = this.childrenAges[index];
    if (age < 0 || !age){
      this.childrenAges[index] = 0;
      return;
    }
    if (age > 17){
      this.childrenAges[index] = 17;
      return;
    } 
    this.childrenAges[index] = Math.floor(age);
  }

  //  confronta le nuove età fornite con quelle iniziali e se sono diverse le invia al service per una nuova ricerca
  setNewAges() {
    for(let i = 0; i < this.childrenAges.length; i++){
      this.checkAgeInput(i);
    }
    this.mergeAges();
    if (this.guestsAges.length === this.oldGuestsAges.length) {
      let sameAges = true;      
      for (let i = 0; i < this.guestsAges.length; i++) {
        if (this.oldGuestsAges[i] !== this.guestsAges[i] ) {
          sameAges = false;
          break;
        }
      }
      if (sameAges) return;
    }
    console.log(this.guestsAges);
    this._bookingService.setNewAges(this.guestsAges);
    this.accordion.collapse("occupancy-panel");
  }

}
